import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { ms } from "./translations/ms";
import { en } from "./translations/en";
import { getDecryptedItem } from "src/server/crypto";

const LANGUAGE_KEY = "__jll_RX15DE6D65AB5D";
const storedLanguage = getDecryptedItem(LANGUAGE_KEY);

i18n.use(initReactI18next).init({
  resources: {
    ms: { translation: ms },
    en: { translation: en },
  },
  lng: storedLanguage || "ms",
  fallbackLng: storedLanguage || "ms",
  interpolation: {
    escapeValue: false,
  },
});
